/* ============================================================
   Gesetzliche Feiertage in Bayern (Muenchen) — berechnet, nicht gepflegt.

   Warum das hier liegt und nicht nur im Backend:
   Die Feiertags-API (my-delivery-app) wird von Hand befuellt und war beim
   Pruefen am 05.09.2026 fuer 2027 komplett leer, fuer 2026 fehlten vier
   Termine. Ohne diese Datei haette der Warenkorb-Kalender ab 01.01.2027
   Lieferungen an Neujahr, Heilige Drei Koenige, Karfreitag und Ostermontag
   angeboten. Beide Quellen werden vereinigt: Was die API zusaetzlich meldet
   (Betriebsferien, Sonderschliessungen), bleibt gueltig.

   Muenchen-Besonderheit: Mariae Himmelfahrt (15.08.) ist in Bayern nur in
   ueberwiegend katholischen Gemeinden Feiertag — Muenchen gehoert dazu.
   Buss- und Bettag ist in Bayern KEIN gesetzlicher Feiertag (nur Sachsen).
   ============================================================ */
(function (w) {
  'use strict';

  function pad2(n) { return n < 10 ? '0' + n : '' + n; }
  function ymd(d) { return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate()); }

  /* Ostersonntag nach der anonymen gregorianischen Osterformel (Meeus/Jones/Butcher).
     Gueltig fuer den gesamten gregorianischen Kalender, ohne Tabellen. */
  function easterSunday(year) {
    var a = year % 19,
        b = Math.floor(year / 100),
        c = year % 100,
        d = Math.floor(b / 4),
        e = b % 4,
        f = Math.floor((b + 8) / 25),
        g = Math.floor((b - f + 1) / 3),
        h = (19 * a + b - d - g + 15) % 30,
        i = Math.floor(c / 4),
        k = c % 4,
        l = (32 + 2 * e + 2 * i - h - k) % 7,
        m = Math.floor((a + 11 * h + 22 * l) / 451),
        month = Math.floor((h + l - 7 * m + 114) / 31),
        day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month - 1, day);
  }

  function plusDays(date, n) {
    var d = new Date(date.getTime());
    d.setDate(d.getDate() + n);
    return d;
  }

  /* Alle bayerischen Feiertage eines Jahres als Array 'YYYY-MM-DD'. */
  function forYear(year) {
    var e = easterSunday(year);
    return [
      year + '-01-01',            // Neujahr
      year + '-01-06',            // Heilige Drei Koenige
      ymd(plusDays(e, -2)),       // Karfreitag
      ymd(plusDays(e, 1)),        // Ostermontag
      year + '-05-01',            // Tag der Arbeit
      ymd(plusDays(e, 39)),       // Christi Himmelfahrt
      ymd(plusDays(e, 50)),       // Pfingstmontag
      ymd(plusDays(e, 60)),       // Fronleichnam
      year + '-08-15',            // Mariae Himmelfahrt (Muenchen)
      year + '-10-03',            // Tag der Deutschen Einheit
      year + '-11-01',            // Allerheiligen
      year + '-12-25',            // 1. Weihnachtstag
      year + '-12-26'             // 2. Weihnachtstag
    ];
  }

  /* Bequemer Zugriff fuer die Aufrufer: laufendes und naechstes Jahr in einem Set.
     Deckt jeden Vorlauf ab, den Kurier oder DPD brauchen koennen. */
  function setAround(date) {
    var y = (date || new Date()).getFullYear();
    var out = {};
    forYear(y).concat(forYear(y + 1)).forEach(function (d) { out[d] = true; });
    return out;
  }

  /* ----------------------------------------------------------
     Naechster moeglicher Kurier-Liefertag.
     Dieselben Regeln wie im Warenkorb-Kalender (my-delivery-widget) und im
     Lieferversprechen (mfl-delivery-promise):
       - vor 06:00 zaehlt der laufende Tag noch, ab 06:00 fruehestens der naechste
       - Sonntag braucht die Bestellung bis Samstag 06:00 (Grossmarkt sonntags zu)
       - ein Feiertag braucht die Bestellung bis zum Vortag 06:00, wobei Sonntage
         und weitere Feiertage uebersprungen werden
     Blackouts kennt diese Funktion bewusst nicht — die haengen an einer API und
     waeren fuer die Topbar ein Netzwerkaufruf auf jeder Seite. Wer sie braucht
     (Lieferversprechen), laedt sie zusaetzlich.
     ---------------------------------------------------------- */
  function nextDeliveryDay(now) {
    var holi = setAround(now);
    function cutoffFor(target) {
      if (target.getDay() !== 0 && !holi[ymd(target)]) return null;
      var d = plusDays(target, -1), guard = 0;
      while ((d.getDay() === 0 || holi[ymd(d)]) && guard < 14) { d = plusDays(d, -1); guard++; }
      d.setHours(6, 0, 0, 0);
      return d;
    }
    var day = new Date(now.getTime());
    day.setHours(0, 0, 0, 0);
    if (now.getHours() >= 6) day.setDate(day.getDate() + 1);
    var guard = 0;
    while (guard < 14) {
      var c = cutoffFor(day);
      if (!c || now.getTime() < c.getTime()) break;
      day.setDate(day.getDate() + 1); guard++;
    }
    return day;
  }

  w.MFL_HOLIDAYS_BY = {
    forYear: forYear,
    setAround: setAround,
    easterSunday: easterSunday,
    nextDeliveryDay: nextDeliveryDay,
    ymd: ymd
  };
})(typeof window !== 'undefined' ? window : globalThis);
